import { PepSection } from '../constants';
import { Box, Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { useFormContext } from 'react-hook-form';
import { TPepEntity } from '~/modules/identification/forms/AdditionalInformation/types.ts';
import { styles } from '~/modules/identification/forms/AdditionalInformation/styles.ts';
import FormGridItem from '~/components/FormComponents/FormGridItem';

interface IClientPepContentProps {
  section: string;
  pepIndex: number;
}

export const ClientPepContent = ({ section, pepIndex }: IClientPepContentProps) => {
  const {
    formState: { errors },
  } = useFormContext<{ additionalInformation: TPepEntity[] }>();
  const fieldErrors = errors?.additionalInformation?.[pepIndex];
  const isClientInfoSection = section.includes(PepSection.pepInfo);

  return (
    <Grid container spacing={3}>
      <FormGridItem>
        <FormInput
          name={`additionalInformation.${pepIndex}.pepInfo.fullName`}
          disabled={isClientInfoSection}
          label="ПІБ"
          placeholder="Введіть повне прізвище, ім'я, по батькові"
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name={`additionalInformation.${pepIndex}.pepInfo.pepPosition`}
          label="Посада та категорія РЕР"
          placeholder="Введіть посаду та категорію РЕР"
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormDateInput
          name={`additionalInformation.${pepIndex}.pepInfo.publicFunctionsStartDate`}
          label="Дата початку виконання публічних функцій"
          placeholder="Введіть дату початку виконання публічних функцій"
          isCurrentMaxDate
        />
      </FormGridItem>
      <FormGridItem>
        <FormDateInput
          name={`additionalInformation.${pepIndex}.pepInfo.publicFunctionsEndDate`}
          label="Дата припинення виконання публічних функцій"
          placeholder="Введіть дату припинення виконання публічних функцій"
          isCurrentMaxDate
        />
      </FormGridItem>
      {typeof fieldErrors === 'string' && <Box sx={styles.textFieldError}>{fieldErrors}</Box>}
    </Grid>
  );
};
